import React from 'react'
import { Switch } from 'react-router-dom'
import { CContainer } from '@coreui/react'
import AuthenticatedRoute from '../components/AuthenticatedRoute'
import Books from '../pages/Books'
import Dashboard from '../pages/Dashboard'
import Bookmarks from '../pages/Bookmarks'
import Pages from '../pages/Pages'

export default function Main() {
  return (
    <div className="c-main">
      <CContainer fluid>
        <Switch>
          <AuthenticatedRoute exact path="/" component={Dashboard} />
          <AuthenticatedRoute  path="/books" component={Books} />
          <AuthenticatedRoute  path="/bookmarks" component={Bookmarks} />
          <AuthenticatedRoute  path="/pages" component={Pages} />
        </Switch>
      </CContainer>
    </div>
  )
}
